var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"index"},[_c('img',{staticStyle:{"width":"167px"},attrs:{"src":"/static/images/null.png"}}),_c('div',{staticClass:"title"},[_vm._v("无系统使用权限")]),_c('div',{staticClass:"sub-title"},[_vm._v("请联系管理员赋权！")])])
}]

export { render, staticRenderFns }